import {library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faQuestion,
  faArrowUp,
  faCalendarAlt,
  faCartArrowDown,
  faCartPlus,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClock,
  faCoffee,
  faEdit,
  faInfoCircle,
  faList,
  faMinusCircle,
  faPencilAlt,
  faPhone,
  faPlusCircle,
  faQuestionCircle,
  faShoppingCart,
  faSignInAlt,
  faThLarge,
  faTimes,
  faTrash,
  faRedo,
  faNewspaper,
  faFile,
  faPen,
  faExclamationCircle,
  faInfo,
  faSearch,
  faAngleLeft,
  faHome,
  faLanguage
} from '@fortawesome/free-solid-svg-icons';

import {
  faCheckCircle as farCheckCircleRegular

} from '@fortawesome/free-regular-svg-icons';

library.add(fab, faCheckSquare, faCoffee, faPhone, faClock,
  faPlusCircle, faMinusCircle, faShoppingCart, faTrash,
  faEdit, faTimes, faSignInAlt, faArrowAltCircleRight, faArrowAltCircleLeft,
  faCalendarAlt, faInfoCircle, faChevronDown, faCartArrowDown, faCartPlus, faQuestionCircle,
  faCheckCircle, faPencilAlt, faChevronLeft, faChevronRight, faArrowUp, faChevronUp, faList,
  faThLarge, faQuestion, faRedo, faNewspaper, faFile, faPen, faExclamationCircle, faInfo, farCheckCircleRegular, faSearch, faAngleLeft, faHome, faLanguage
);

export default library;
